import React from 'react';
import { mapApplicantSummary } from 'plantDesign/utils/PlantDesignSummaryFormatHelper';
import styles from '../PlantDesignReview.module.scss';

export const ApplicantDetailsReview = (props) => {
  const { data = {} } = props;

  const formattedApplicantDetails = mapApplicantSummary(data);

  return formattedApplicantDetails.map(
    (prop) =>
      prop.value && (
        <div key={prop.text}>
          <div className={styles.summaryLabel}>{prop.text}</div>
          <div className={styles.summaryValue}>{prop.value}</div>
        </div>
      ),
  );
};
